import { TableOfContentsItem } from "@/components/blog/TableOfContents";

export const tendenciasSeo2026TableOfContents: TableOfContentsItem[] = [
  {
    id: "transformacion-seo-ia",
    title: "La gran transformación: de SEO clásico a SEO para IA",
    subItems: [
      { id: "nuevo-paradigma", title: "El nuevo paradigma de búsqueda" },
      { id: "confianza-vs-clics", title: "Confianza vs. clics: el cambio de mentalidad" }
    ]
  },
  {
    id: "busqueda-conversacional",
    title: "Búsqueda conversacional, por voz y multimodal",
    subItems: [
      { id: "voz-asistentes", title: "Voz y asistentes inteligentes" },
      { id: "busqueda-visual", title: "Búsqueda visual y multimedia" }
    ]
  },
  {
    id: "optimizacion-tecnica-ux",
    title: "Optimización técnica y experiencia de usuario",
    subItems: [
      { id: "core-web-vitals", title: "Core Web Vitals y rendimiento" },
      { id: "mobile-first", title: "Mobile-first y accesibilidad" }
    ]
  },
  {
    id: "autoridad-marca-eeat",
    title: "Autoridad de marca, E-E-A-T y señales de confianza",
    subItems: [
      { id: "eeat-real", title: "E-E-A-T real: experiencia demostrada" },
      { id: "reputacion-digital", title: "Reputación digital y branding" }
    ]
  },
  {
    id: "contenido-semantico",
    title: "Contenido semántico y listo para IA",
    subItems: [
      { id: "estructura-citacion", title: "Estructura optimizada para citación" },
      { id: "contenido-multimodal", title: "Contenido multimodal: texto, vídeo y audio" }
    ]
  },
  {
    id: "seo-local-2026",
    title: "SEO local y personalización contextual",
    subItems: [
      { id: "geolocalizacion", title: "Geolocalización y búsquedas cercanas" },
      { id: "segmentacion-contexto", title: "Segmentación por contexto y audiencia" }
    ]
  },
  {
    id: "checklist-accion",
    title: "Checklist 2026: plan de acción inmediato",
    subItems: [
      { id: "pasos-implementar", title: "7 pasos para implementar hoy" },
      { id: "errores-evitar", title: "Errores comunes a evitar" }
    ]
  }
];
